import { NetGainFilterInput } from '@allocab/allocab-driver-shared-types';
import { NetGainOutput } from '@allocab/allocab-invoice-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

const fetchNetGains = (input: NetGainFilterInput) =>
  driverApi.post<NetGainFilterInput, NetGainOutput>(`/v1/net-gains`, input);

export const useFetchNetGains = (input: NetGainFilterInput = {}) => {
  return useQuery({
    queryKey: queryKeys.user.fetchNetGains(input),
    queryFn: () => fetchNetGains(input),
  });
};
